import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { lightTheme as theme } from '../../theme';

const softVariants = {
    danger: { background: theme.colors.dangerBg, color: theme.colors.danger },
    success: { background: theme.colors.successBg, color: theme.colors.success },
    info: { background: theme.colors.infoBg, color: theme.colors.info },
    warning: { background: theme.colors.warningBg, color: theme.colors.warning },
    neutral: { background: theme.colors.gray100, color: theme.colors.textSecondary },
    workshop: { background: 'rgba(34, 197, 94, 0.15)', color: theme.colors.success },
    company: { background: 'rgba(13, 110, 253, 0.15)', color: theme.colors.info },
    maintenanceWorkshop: { background: 'rgba(25, 135, 84, 0.14)', color: '#198754' },
    maintenanceInCompany: { background: 'rgba(13, 110, 253, 0.14)', color: '#0d6efd' },
};

const onDarkVariants = {
    neutral: {
        background: 'rgba(255, 255, 255, 0.14)',
        color: theme.colors.headerText,
        border: '1px solid rgba(255, 255, 255, 0.68)',
    },
    danger: {
        background: 'rgba(255, 255, 255, 0.14)',
        color: theme.colors.headerText,
        border: '1px solid rgba(255, 255, 255, 0.68)',
    },
    info: {
        background: 'rgba(255, 255, 255, 0.14)',
        color: theme.colors.headerText,
        border: '1px solid rgba(255, 255, 255, 0.68)',
    },
    success: {
        background: theme.colors.successBg,
        color: theme.colors.success,
        border: 'none',
    },
    warning: {
        background: theme.colors.warningBg,
        color: theme.colors.warning,
        border: 'none',
    },
};

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;

    ${({ $variant, $context }) => {
        if ($context === 'onDark') {
            const darkStyle = onDarkVariants[$variant] || onDarkVariants.neutral;
            return css`
                background: ${darkStyle.background};
                color: ${darkStyle.color};
                border: ${darkStyle.border || 'none'};
            `;
        }

        const style = softVariants[$variant] || softVariants.neutral;
        return css`
            background: ${style.background};
            color: ${style.color};
        `;
    }}
`;

function StatusPill({ variant, children, title, className, context }) {
    return (
        <Badge
            className={className}
            $variant={variant}
            $context={context}
            title={title || String(children)}
        >
            {children}
        </Badge>
    );
}

StatusPill.propTypes = {
    variant: PropTypes.oneOf([
        'danger',
        'success',
        'info',
        'warning',
        'neutral',
        'workshop',
        'company',
        'maintenanceWorkshop',
        'maintenanceInCompany',
    ]),
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    context: PropTypes.oneOf(['default', 'onDark']),
};

StatusPill.defaultProps = {
    variant: 'neutral',
    title: undefined,
    className: undefined,
    context: 'default',
};

export default StatusPill;

